module.exports = __webpack_public_path__ + "img/text.f96455d4.png";